import React, { Suspense, lazy, useEffect, useState } from "react";

// /f/#<practiceid>_<secret> -- the public patient forms page. Tiny route
// shell: the page (renderer, CSS, definitions arrive from the server) is a
// lazy chunk. The token lives in the URL fragment, so it never reaches a
// server log or a Referer; it stays in the address bar, so a reload works.
// App.js keeps the staff shell (header, side nav, login redirect, update
// banner) off this route ("/f/" is in unrestrictedRoutes).
const PatientFormsPage = lazy(() => import("./PatientFormsPage"));

export function readToken(loc = typeof window !== "undefined" ? window.location : null) {
  const raw = ((loc && loc.hash) || "").slice(1);
  try {
    return decodeURIComponent(raw).trim();
  } catch (_) {
    return raw.trim();
  }
}

// A failed chunk load (flaky mobile data) or a render crash shows a
// bilingual retry screen instead of a blank page.
export class PatientPageBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch() {
    /* nothing is logged: the page holds patient data */
  }

  render() {
    if (!this.state.failed) return this.props.children;
    const box = { maxWidth: 520, margin: "15vh auto 0", padding: "0 16px", fontFamily: "Inter, -apple-system, Segoe UI, Roboto, sans-serif", color: "#17212b", textAlign: "center" };
    const btn = { minHeight: 48, padding: "0 22px", borderRadius: 12, border: 0, background: "#1d6b74", color: "#fff", fontSize: 17, fontWeight: 650, cursor: "pointer", marginTop: 18 };
    return (
      <div style={box} role="alert">
        <h1 style={{ fontSize: 24, margin: "0 0 8px" }}>Something went wrong</h1>
        <p style={{ margin: 0, color: "#46525f" }} lang="es">Algo salió mal</p>
        <p style={{ margin: "12px 0 0", color: "#46525f" }}>Please reload the page. · Vuelva a cargar la página.</p>
        <button type="button" style={btn} onClick={() => window.location.reload()}>Reload · Recargar</button>
      </div>
    );
  }
}

export default function PatientFormsRoute() {
  const [token, setToken] = useState(() => readToken());
  useEffect(() => {
    const onHash = () => setToken(readToken());
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);
  return (
    <PatientPageBoundary>
      <Suspense fallback={<div style={{ minHeight: "100vh", background: "#f4f6f7" }} />}>
        <PatientFormsPage key={token} token={token} />
      </Suspense>
    </PatientPageBoundary>
  );
}
